import { TextureLoader } from 'three';
import OBJLoader from '@/scripts/OBJLoader';

const loader = {
  models: new OBJLoader(),
  textures: new TextureLoader(),
};

export default loader;
